import { i18n } from '../i18n'
import type { TranslationKey } from '../types/TranslationKey'

const getCurrentLocaleMessage = (key: string): unknown => {
  const localeMessage = i18n.global.getLocaleMessage(i18n.global.locale.value) as Record<string, unknown>

  return key.split('.').reduce<unknown>((value, segment) => {
    if (!value || typeof value !== 'object') {
      return undefined
    }

    return (value as Record<string, unknown>)[segment]
  }, localeMessage)
}

export const t = (key: string, params?: Record<string, unknown> | unknown[]) =>
  params === undefined ? i18n.global.t(key) : (i18n.global.t as any)(key, params)
export const tt = (message?: TranslationKey) =>
  message ? t(message.key, (message as any).params ?? {}) : ''
export const tOptional = (key: string, params?: Record<string, unknown> | unknown[]) => {
  if (typeof getCurrentLocaleMessage(key) !== 'string') {
    return null
  }

  const translated = t(key, params)
  const normalized = translated.trim()

  return normalized ? normalized : null
}
export const tm = <T>(key: string, fallback?: T): T =>
  (i18n.global.tm(key) as unknown as T | undefined) ?? (fallback as T)
